import "../../WPSTransaction/PDF/Css/Download_pdf.css";

const PageFooter = ({
  pdf,

  previewuser,
  previewapproved,

}) => {
  return (

      <div style={{ position: "relative", top: "0px" }}>
        <table className="WPSnoborder" style={{ width: "70%" }}>
          <tr>
            <td className="WPSSignatureTable" style={{ width: "250px" }}>
              Supervised by - Welding Engineer
            </td>
            <td
              className="WPSSignatureTable"
              style={{ position: "relative", left: "40px" }}
            >
              Approved By
            </td>
          </tr>
        </table>
        <table id="table" className="WPSTable11">
          <tbody>
            <tr style={{ borderBottom: "none" }}>
              <th style={{ borderBottom: "none" }}>Name</th>
              <th
                style={{
                  borderBottom: "none",
                  borderLeft: "none",
                  borderRight: "none",
                }}
              >
                Signature
              </th>
              <th style={{ borderBottom: "none" }}>Name</th>

              <th style={{ borderBottom: "none", borderLeft: "none" }}>
                Signature
              </th>
            </tr>
            <td style={{ borderBottom: "none" }}>
              {pdf[0]?.WPSH_PreparedBy_Name}
            </td>

            <td rowSpan={3} style={{ borderLeft: "none", borderRight: "none" }}>
              {previewuser && previewuser !== "" && (
                <img
                  style={{
                    width: "95%",
                    marginTop: "4%",
                    marginLeft: "2%",
                    marginBottom: "3%",
                    height: "30px",
                  }}
                  src={previewuser}
                  crossOrigin="anonymous"
                />
              )}
            </td>

            <td style={{ borderBottom: "none" }}>
              {pdf[0]?.WPSH_ApprovedBy_Name}
            </td>
            <td rowSpan={3} style={{ borderLeft: "none" }}>
              {previewapproved && previewapproved !== "" && (
                <img
                  style={{
                    width: "95%",
                    marginTop: "4%",
                    marginLeft: "2%",
                    marginBottom: "3%",
                    height: "30px",
                  }}
                  src={previewapproved}
                  crossOrigin="anonymous"
                />
              )}
            </td>

            <tr>
              <th style={{ borderBottom: "none" }}>Date</th>

              <th style={{ borderBottom: "none" }}>Date</th>
            </tr>

            <tr>
              <td>
                {pdf[0]?.WPSH_PreparedBy_Date
                  ? pdf[0]?.WPSH_PreparedBy_Date
                  : ""}
              </td>
              <td>
                {pdf[0]?.WPSH_ApprovedBy_Date
                  ? pdf[0]?.WPSH_ApprovedBy_Date
                  : ""}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

  );
};

export default PageFooter;
